import Neighborhood from '@models/Neighborhood';

import { fetchApi } from './fetchApi';

export async function getNeighborhoods(token: string, agencyId?: number) {
  return fetchApi<Neighborhood[]>('GET', '/neighborhoods', token, {
    query: { agencyId },
  });
}
